import { HeaderComponent } from '@shared/components/header/header.component';
import { AutocompleteChipComponent } from './components/custom-types/autocomplete-chip/autocomplete-chip.component';
import { AutocompleteTypeComponent } from './components/custom-types/autocomplete-type/autocomplete-type.component';
import { ButtonTypeComponent } from './components/custom-types/button-type/button-type.component';
import { ChipTypeComponent } from './components/custom-types/chip-type/chip-type.component';
import { DatetimePickerTypeComponent } from './components/custom-types/datetime-picker-type/datetime-picker-type.component';
import { DecimalThousandNumberTypeComponent } from './components/custom-types/decimal-thousand-number-type/decimal-thousand-number-type.component';
import { LabelTypeComponent } from './components/custom-types/label-type/label-type.component';
import { SelectTypeComponent } from './components/custom-types/select-type/select-type.component';
import { TabsTypeComponent } from './components/custom-types/tabs-type/tabs-type.component';
import { ArrayTypeComponent } from './components/wrappers/array-type/array-type.component';
import { FullScreenWrapperComponent } from './components/wrappers/full-screen-wrapper/full-screen-wrapper.component';
import { HiddenTypeComponent } from './components/wrappers/hidden-type/hidden-type.component';
import { MultiSchemaTypeComponent } from './components/wrappers/multi-schema-type/multi-schema-type.component';
import { NullTypeComponent } from './components/wrappers/null-type/null-type.component';
import { ObjectTypeComponent } from './components/wrappers/object-type/object-type.component';
import { PanelWrapperWithHeaderComponent } from './components/wrappers/panel-wrapper-with-header/panel-wrapper-with-header.component';
import { PanelWrapperComponent } from './components/wrappers/panel-wrapper/panel-wrapper.component';
import { RowWrapperComponent } from './components/wrappers/row-wrapper/row-wrapper.component';

export const COMPONENT_CONFIG = {
  validationMessages: [
    { name: 'required', message: 'This field is required' },
    { name: 'maxLength', message: 'This field cannot exceed 100 characters' },
  ],
  types: [
    { name: 'autocomplete', component: AutocompleteTypeComponent },
    { name: 'chip', component: ChipTypeComponent },
    { name: 'datetimePicker', component: DatetimePickerTypeComponent },
    { name: 'button', component: ButtonTypeComponent },
    { name: 'object', component: ObjectTypeComponent },
    { name: 'hidden', component: HiddenTypeComponent },
    { name: 'array', component: ArrayTypeComponent },
    { name: 'multischema', component: MultiSchemaTypeComponent },
    { name: 'null', component: NullTypeComponent, wrappers: ['form-field'] },
    { name: 'label', component: LabelTypeComponent },
    { name: 'dynamicSelect', component: SelectTypeComponent },
    { name: 'autocompleteChip', component: AutocompleteChipComponent },
    { name: 'decimalThousandNumber', component: DecimalThousandNumberTypeComponent },
  ],
  wrappers: [
    { name: 'tabs', component: TabsTypeComponent },
    { name: 'panel', component: PanelWrapperComponent },
    { name: 'header', component: HeaderComponent },
    { name: 'itemWrapper', component: RowWrapperComponent },
    { name: 'fullScreenWrapper', component: FullScreenWrapperComponent },
    { name: 'panelWrapperWithHeader', component: PanelWrapperWithHeaderComponent },
  ],
};
